// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__DytJM","content":"ManualTimeModal_content__3EG72"};